<section>
  <h1>Export</h1>
  <article>
    <mat-radio-group [(ngModel)]="select">
      <mat-radio-button *ngIf="canExportCurrent" value="c">Compte Client sélectionné</mat-radio-button>
      <mat-radio-button *ngIf="canExportCurrentAndCS" value="cs">Compte et sous-comptes du client
        sélectionné</mat-radio-button>
      <mat-radio-button *ngIf="canExportAll" value="all">Tous les Comptes et sous-comptes de votre
        profil</mat-radio-button>
    </mat-radio-group>

    <mat-checkbox *ngIf="canCheckOkCab" [(ngModel)]="exportOkCab">ID VT OK</mat-checkbox>

    <form *ngIf="consoHistoryForm" [formGroup]="consoHistoryForm">
      <mat-form-field *ngIf="rangePicker">
        <input matInput [matDatepicker]="fromPicker" formControlName="dateMin" placeholder="Date min">
        <mat-error *ngIf="consoHistoryForm.hasError('required',['dateMin'])">Une date minimum est requise</mat-error>
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field *ngIf="rangePicker">
        <input matInput [matDatepicker]="toPicker" formControlName="dateMax" placeholder="Date max">
        <mat-error *ngIf="consoHistoryForm.hasError('required',['dateMax'])">Une date maximum est requise</mat-error>
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field *ngIf="selectOptions">
        <mat-label>Type d'affichage</mat-label>
        <mat-select formControlName="typeAffichage">
          <mat-option *ngFor="let selectOption of selectOptions" [value]="selectOption.value">
            {{ selectOption.view }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="typesConso">
        <mat-label>Type de ligne</mat-label>
        <mat-select formControlName="typeConso">
          <mat-option *ngFor="let type of typesConso" [value]="type.value">
            {{ type.view }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <p>
      <button mat-raised-button color="primary" [disabled]="(consoHistoryForm && consoHistoryForm.invalid) || loading"
        (click)="export()" class="button-spinner{{loading?'-loading':''}}" id="export-button">
        <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>Export (XLSX)
      </button>
    </p>
  </article>
</section>